import React from 'react';
import {useLocation} from 'react-router-dom';
import styles from './footer.module.scss';
import FooterItem from './item';

const menus: Array<IMenu> = [
  {
    title: 'داشبورد',
    icon: 'icon-dashboard',
    activeIcon: 'icon-dashboard',
    route: '/lab/home',
  },
  {
    title: 'پیام ها',
    icon: 'icon-chat',
    activeIcon: 'icon-chat-active',
    route: '/lab/message',
  },
  {
    title: 'مدیریت آزمایشگاه',
    icon: 'icon-manage',
    activeIcon: 'icon-manage-active',
    route: '/lab/manage',
  },
];
const LabFooter = () => {
  const {pathname} = useLocation();
  return (
    <>
      <div className={styles.footer}>
        <div className="d-flex justify-content-around align-items-center h-100">
          {React.Children.toArray(
            menus.map(item => (
              <>
                <FooterItem
                  isMain={item?.isMain}
                  title={item?.title}
                  icon={
                    pathname.includes(item.route)
                      ? item?.activeIcon
                      : item?.icon
                  }
                  router={item?.route}
                  isActive={pathname.includes(item.route)}
                />
              </>
            )),
          )}
        </div>
      </div>
    </>
  );
};

export default LabFooter;
